import { Button } from "react-bootstrap";

/**
 * Generic prev/next pagination bar.
 *
 * @param {number}   currentPage
 * @param {number}   totalPages
 * @param {function} onPageChange  - called with the new page index
 */
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="pagination-controls d-flex justify-content-center align-items-center my-3">
      <Button
        variant="secondary"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 0}
        className="mx-2"
      >
        Previous
      </Button>
      <span>{`Page ${currentPage + 1} of ${totalPages}`}</span>
      <Button
        variant="secondary"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage + 1 >= totalPages}
        className="mx-2"
      >
        Next
      </Button>
    </div>
  );
};

export default Pagination;
